import styled from "@emotion/styled";
import { Box, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { Link, Typography } from "@kaltura/ds-react-components";

export const StyledPageBox = styled(Box)(({ theme }) => ({
    "&": systemWidth({ theme }),
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.typography.pxToRem(120),
    marginRight: theme.typography.pxToRem(120),
    [theme.breakpoints.down("md")]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
}));

export const StyledBackLink = styled(Link<"a">)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(-2),
    cursor: "pointer",
}));
